import { compose } from 'recompose'
import { FLEET_CERTIFIED_MODAL } from 'components/StoreDetailsPage/constants'
import registerReduxModal from 'components/common/hoc/registerReduxModal'
import FleetCertifiedModal from './FleetCertifiedModal'

export default compose(
  registerReduxModal({ name: FLEET_CERTIFIED_MODAL })
)(FleetCertifiedModal)

